import { 
  signInWithEmailAndPassword,
  signOut as firebaseSignOut,
  onAuthStateChanged,
  type User
} from 'firebase/auth';
import { auth } from './firebase';

const MAX_LOGIN_ATTEMPTS = 5;
const LOCKOUT_DURATION = 15 * 60 * 1000; // 15 minutes

let loginAttempts = 0;
let lockoutTime = 0;

export async function signIn(email: string, password: string) {
  // Check for lockout
  if (lockoutTime > Date.now()) {
    throw new Error('Account temporarily locked. Please try again later.');
  }

  // Increment login attempts
  loginAttempts++;

  // Check if max attempts reached
  if (loginAttempts >= MAX_LOGIN_ATTEMPTS) {
    lockoutTime = Date.now() + LOCKOUT_DURATION;
    loginAttempts = 0;
    throw new Error('Too many login attempts. Please try again later.');
  }

  const { user } = await signInWithEmailAndPassword(auth, email, password);
  
  // Reset attempts on successful login
  loginAttempts = 0;
  
  return { user };
}

export async function signOut() {
  await firebaseSignOut(auth);
}

export function getCurrentUser(): User | null {
  return auth.currentUser;
}

export function onAuthStateChange(callback: (user: User | null) => void) {
  return onAuthStateChanged(auth, callback);
}